import { defineMessages } from 'react-intl';

export const audioMessages = defineMessages({
	title: {
		id: 'audio.title',
		defaultMessage: 'Do you want to send:',
		description:
			'"Do you want to send:" text placed in modal header after click on audio icon',
	},
	permission_error: {
		id: 'audio.permission_error',
		defaultMessage:
			'There was an error while recording. Be sure to allow the use of microphone and retry',
		description:
			'This error message will be displayed on the place of textarea if user not allow the page to use microphone',
	},
	audio: {
		id: 'audio.audio',
		defaultMessage: 'Audio',
		description: '"Audio" text placed in modal body in audio option list',
	},
	transcript: {
		id: 'audio.transcript',
		defaultMessage: 'Transcript',
		description: '"Transcript" text placed in modal body in audio option list',
	},
	recording_audio: {
		id: 'audio.recording',
		defaultMessage: 'Recording audio ( {minutes}:{seconds} )',
		description:
			'"Recording audio" text placed in textarea/preview box while recording',
	},
	enable_microphone_warning: {
		id: 'audio.enable_microphone_warning',
		defaultMessage: 'Do you want send audio message using microphone?',
	},
});
